import get from 'lodash/get'
import api from '~/api'

let scopesLoadedResolveFn
const loadedPromise = new Promise(resolve => {
  scopesLoadedResolveFn = resolve
})

const state = () => {
  return {
    user: null,
    provider: null,
    scopes: [],
    loadedPromise,
  }
}

const includes = key => ({ scopes }) => scopes.indexOf(key) !== -1

const getters = {
  user: s => s.user,
  provider: s => s.provider,
  meProviderName: s => get(s.provider, 'name', ''),
  meProviderId: s => get(s.provider, 'id', ''),
  scopes: s => s.scopes,
  hasPermission: s => key => s.scopes.indexOf(key) !== -1,
  showCurrentUser: includes('current_user:read'),
  canSwitchProvider: s => false,
}

const mutations = {
  SET_ME(state, payload) {
    const payloadCopy = Object.assign({}, payload)

    state.scopes = payloadCopy.scopes
    state.provider = payloadCopy.provider

    delete payloadCopy.scopes
    delete payloadCopy.provider

    state.user = payloadCopy
  },
}

const actions = {
  async GET_ME({ state, commit }) {
    const [error, me] = await api.get('/me')

    if (error) {
      console.error(error)
      return
    }

    commit('SET_ME', me)
    scopesLoadedResolveFn()
  },
  async SET_ME({ commit }, payload) {
    const [error, success] = await api.put('/me', payload)

    if (error) {
      console.error(error)
    }

    return [error, success]
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
